// extracted by mini-css-extract-plugin
export default {"SkillPage":"SkillPage_SkillPage__7oPZT","Borderless":"SkillPage_Borderless__G5MSQ","SkillType":"SkillPage_SkillType__WTWXv"};